import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";

const ALLOWED_USERS = ["david.turton@wmplp.com"];

// Injects the LiveKit voice-agent embed only for allowlisted users.
// The script adds its own floating button to the DOM on load.
export function LiveKitWidget() {
  const { accounts } = useMsal();
  const email = accounts[0]?.username?.toLowerCase() ?? "";

  useEffect(() => {
    if (!ALLOWED_USERS.includes(email)) return;
    if (document.querySelector('script[src*="embed-popup.js"]')) return;
    const script = document.createElement("script");
    script.src = "https://cloud.livekit.io/embed-popup.js";
    script.dataset.lkAgent = "CA_xusnUU3Z72nu";
    script.dataset.lkColor = "#002CF2";
    document.body.appendChild(script);
  }, [email]);

  return null;
}
